{
  "cashier": "Kassa",
  "depositTab": "Depozit",
  "withdrawTab": "Yechib olish",
  "historyTab": "Tarix",
  "secureNote": "Xavfsiz va shifrlangan",
  "selectMethod": "To‘lov usulini tanlang",
  "amount": "Summa",
  "amountPlaceholder": "Summani kiriting",
  "quickAmounts": "Tezkor summalar",
  "continue": "Davom etish",
  "depositNow": "Depozit qilish",
  "withdrawNow": "Yechib olish so‘rovi",
  "methodDisabled": "Bu usul hali faol emas",
  "methodsPending": "To‘lov rekvizitlari admin tomonidan hali sozlanmagan",
  "receiptRequired": "Chek yuklash talab qilinadi — chek to‘lov tasdig‘i emas",
  "adminVerification": "Balans faqat mustaqil admin tekshiruvidan keyin oshadi",
  "noCryptoNetworks": "Kripto tarmoqlari sozlanmagan",
  "noAddress": "Depozit manzili hali belgilangan emas",
  "cardToCard": "Kartadan kartaga",
  "cardToCardDesc": "Bank kartasiga o‘tkazma",
  "m10": "M10",
  "m10Desc": "M10 o‘tkazmasi",
  "terminal": "Terminal",
  "terminalDesc": "Terminal to‘lovi",
  "crypto": "Kriptovalyuta",
  "cryptoDesc": "Kripto depozit",
  "bankCardWithdraw": "Bank kartasi",
  "m10Withdraw": "M10",
  "cryptoWithdraw": "Kripto",
  "minMax": "Min {{min}} — Max {{max}}",
  "trustInstant": "Sozlanganda tez qayta ishlash",
  "trustSecure": "Xavfsiz amaliyotlar",
  "trustMethods": "Karta, M10, Terminal, Kripto",
  "historyEmpty": "Tranzaksiya yo‘q",
  "historyAuth": "Tarixni ko‘rish uchun kiring",
  "balanceTitle": "Balans",
  "openCashier": "Kassa",
  "topUp": "To‘ldirish",
  "bonusAccount": "Bonus hisobi",
  "reservedFunds": "Rezerv",
  "copyId": "ID ni nusxalash",
  "loginRequired": "Davom etish uchun kiring",
  "region": "To‘lov hududi",
  "instructionsSoon": "Rekvizit tayinlangandan so‘ng ko‘rsatmalar shu yerda chiqadi",
  "uploadReceipt": "Chek yuklash",
  "uploadDisabled": "Depozit so‘rovi yaratilmasdan chek qabul qilinmaydi",
  "depositCreated": "Depozit so‘rovi yaratildi",
  "receiptUploaded": "✅ Chek yuklandi. To‘lov so‘rovi qayd etildi. Kuting.",
  "withdrawReserved": "Yechib olish rezervlandi",
  "destination": "Qabul qiluvchi ma’lumotlari",
  "destinationRequired": "Qabul qiluvchi ma’lumotlarini kiriting",
  "noCvv": "CVV va PIN talab qilinmaydi va qabul qilinmaydi",
  "status": "Holat",
  "copy": "Nusxa",
  "bankPayment": "Bank to‘lovi",
  "currentBalance": "Joriy balans: {{amount}}",
  "copied": "Nusxa olindi",
  "selectCoin": "Coin",
  "selectNetwork": "Tarmoq",
  "timeRemaining": "Qolgan vaqt",
  "depositExpired": "Bu depozit sorovining muddati tugadi. Yangisini yarating.",
  "cancelDeposit": "Sorovni bekor qilish",
  "qrLabel": "Depozit manzili QR",
  "copyAddress": "Manzil",
  "cardHolder": "Karta egasi (ixtiyoriy)",
  "sendExactAmount": "Korsatilgan summani aniq yuboring. Notogri tarmoq yoki summa hisobga olinmaydi.",
  "noPairsConfigured": "Coin/tarmoq jufti hali sozlanmagan",
  "depositCancelled": "Depozit sorovi bekor qilindi",
  "usdRate": "1 USD = {{rate}} AZN",
  "minUsd": "Min ${{usd}}",
  "saveQr": "QR ni saqlash",
  "networkWarning": "Faqat {{network}} tarmog‘iga yuboring. Noto‘g‘ri tarmoq mablag‘ yo‘qolishiga olib kelishi mumkin.",
  "filter_all": "Hammasi",
  "filter_deposit": "Depozit",
  "filter_withdrawal": "Yechib olish",
  "field_card_number": "Karta raqami",
  "field_card_holder": "Karta egasi",
  "field_bank_name": "Bank",
  "field_m10_account": "M10 hisobi",
  "field_account_holder": "Hisob egasi",
  "field_terminal_code": "Terminal kodi",
  "field_address": "Manzil",
  "field_asset": "Coin",
  "field_network": "Tarmoq",
  "field_memo": "Memo",
  "field_phone": "Telefon",
  "field_iban": "IBAN",
  "field_name": "Ism",
  "methodSelected_card_to_card": "Kartadan kartaga tolov tanlandi",
  "methodSelected_m10": "M10 tolovi tanlandi",
  "methodSelected_terminal": "Terminal orqali tolov tanlandi",
  "methodSelected_crypto": "Kriptovalyuta tanlandi",
  "cryptoUnavailable": "Kriptovalyuta depoziti hali tayyor emas",
  "cryptoUnavailableHint": "Qabul qilish manzili va tarmoq admin tomonidan sozlanmagan. Mablag' yubormang — soxta hamyon ko'rsatilmaydi.",
  "quotePreview": "Kotirovka",
  "expectedCredit": "Kutilayotgan AZN kredit",
  "estimatedCrypto": "Taxminiy kripto miqdori",
  "adminRateNote": "Bu kurs admin tomonidan belgilangan, jonli bozor narxi emas.",
  "enterAmountFirst": "Avval miqdorni kiriting, keyin tanga va tarmoqni tanlang.",
  "status_waiting_for_payment": "To'lov kutilmoqda",
  "status_detected": "O'tkazma aniqlandi",
  "status_awaiting_confirmations": "Tasdiqlar kutilmoqda",
  "status_pending_review": "Ko'rik kutilmoqda",
  "status_confirmed": "Tasdiqlandi",
  "status_expired": "Muddati tugadi",
  "status_ambiguous": "Qo'lda tekshiruv kerak",
  "status_error": "Xato / qo'llab-quvvatlanmaydi",
  "status_cancelled": "Bekor qilindi",
  "status_rejected": "Rad etildi",
  "status_approved": "Tasdiqlandi",
  "expiredLateNote": "Muddat tugagandan keyin ham blockchain o'tkazmasi kelishi mumkin. U avtomatik kreditlanmaydi va izlanadigan tekshiruv talab qiladi.",
  "enlargeQr": "QR ni kattalashtirish",
  "closeQr": "Yopish",
  "confirmationTimeNote": "10 daqiqalik taymer so'rov kutish oynasi, blockchain tasdig'i emas.",
  "usdEquivalent": "USD ekvivalenti: ${{usd}}",
  "quoteUnavailable": "Kotirovka mavjud emas. Miqdor va tarmoqni tekshiring.",
  "depositRequests": "Depozit so'rovlari",
  "networkMismatch": "Faqat ko'rsatilgan tarmoqqa yuboring.",
  "safeRecovery": "Aloqa uzildi. Oxirgi saqlangan so'rov tiklanadi.",
  "historyAll": "Hammasi",
  "historyDeposit": "Depozit",
  "historyWithdrawal": "Yechib olish",
  "historyEmptyTitle": "Amaliyotlar tarixi bo‘sh",
  "historyEmptyDescription": "Depozit va pul yechish so‘rovlaringiz shu yerda ko‘rsatiladi.",
  "historyBankDeposit": "Bank depoziti",
  "statusPending": "Kutilmoqda",
  "statusReview": "Tekshirilmoqda",
  "statusApproved": "Tasdiqlandi",
  "statusPaid": "To‘landi",
  "statusCompleted": "Yakunlandi",
  "statusRejected": "Rad etildi",
  "statusExpired": "Muddati tugadi",
  "statusCancelled": "Bekor qilindi",
  "statusFailed": "Muvaffaqiyatsiz",
  "withdrawAcceptedClean": "Pul yechish so‘rovingiz qabul qilindi va tekshirishga yuborildi.",
  "selectBankLocal": "Bankni tanlang",
  "holderFullNameLocal": "Karta egasining ism-familiyasi",
  "recipientCardLocal": "Qabul qiluvchi karta raqami",
  "availableBalanceLocal": "Mavjud balans",
  "backWithdrawalLocal": "Ortga — yechish usullari",
  "withdrawDetailsLocal": "Pul yechish ma’lumotlarini kiriting",
  "paymentMethodsLocal": "To‘lov usullari",
  "paymentAmountLocal": "To‘lov summasi",
  "transactionTypeLocal": "Amaliyot turi",
  "walletSectionsLocal": "Hamyon bo‘limlari",
  "cryptoTransferTitle": "Kriptovalyuta depoziti",
  "cryptoTransferAmount": "Yuboriladigan summa",
  "cryptoOrderAmount": "Buyurtma summasi",
  "cryptoTransferAddress": "Hamyon manzili",
  "cryptoTransferNetwork": "Tarmoq",
  "cryptoShowQr": "QR kodni ochish",
  "cryptoQrWaiting": "QR kod mavjud emas",
  "cryptoNoAddress": "Manzil mavjud emas. Mablag‘ yubormang.",
  "cryptoWarnNetwork": "Faqat {{asset}} valyutasini {{network}} tarmog‘i orqali yuboring. Noto‘g‘ri tarmoqda mablag‘ yo‘qolishi mumkin.",
  "cryptoWarnAmount": "Miqdor va tarmoq komissiyasini tekshiring. Yetarli bo‘lmagan o‘tkazma hisobga olinmasligi mumkin.",
  "cryptoMoreInfo": "Qo‘shimcha ma’lumot",
  "cryptoMemo": "Memo / Tag",
  "prevStep": "Oldingi bosqich",
  "depositAmount": "Depozit summasi",
  "paymentInstruction": "To‘lov ko‘rsatmasi",
  "paymentConfirm": "To‘lovni tasdiqlash",
  "depositStages": "Depozit bosqichlari",
  "stageAmount": "Summa",
  "stagePayment": "To‘lov",
  "stageReceipt": "Chek",
  "receiptSend": "Chek yuborish",
  "rejected": "Rad etildi",
  "network": "Tarmoq",
  "paymentNote": "To‘lov izohi",
  "extraPaymentInfo": "Qo‘shimcha to‘lov ma’lumoti",
  "invalidAmount": "To‘g‘ri summa kiriting.",
  "tapToSelect": "Tanlash uchun bosing",
  "walletLabel": "Hamyon",
  "previewBanner": "SINOV REJIMI: Barcha to‘lov kartlari tanlanadi. Haqiqiy pul yubormang; depozit/yechib olish bajarilmaydi.",
  "otherBank": "Boshqa bank",
  "cryptoAsset": "Kriptovalyuta",
  "receiveAddress": "Qabul manzili",
  "notAssigned": "Tayinlanmagan",
  "paymentMethod": "To‘lov usuli",
  "bank": "Bank",
  "recipient": "Oluvchi",
  "cardNumber": "Karta raqami",
  "qrWhenReady": "QR faqat haqiqiy manzil bo‘lganda ko‘rsatiladi",
  "qrInactive": "QR faol emas",
  "qrInactiveHint": "Manzil tayinlanganda shu yerda chiqadi.",
  "networkAttention": "Diqqat: {{network}} tarmog‘i",
  "networkAttentionBody": "Faqat tanlangan tarmoq manziliga yuboring. Noto‘g‘ri tarmoq yoki summa mablag‘ yo‘qolishiga olib kelishi mumkin.",
  "minDepositFees": "Minimal depozit va komissiya",
  "minDepositFeesBody": "Yuborishdan oldin minimum va komissiyani tekshiring.",
  "waitingTransfer": "O‘tkazmangizni kutamiz",
  "waitingTransferBody": "Faqat tasdiqlangan rekvizitlarga aniq summada to‘lang.",
  "wrongTransfer": "Noto‘g‘ri o‘tkazmalar haqida",
  "wrongTransferBody": "Boshqa bank/karta yoki summaga to‘lov hisobga tushmasligi mumkin.",
  "previewNoAddress": "SINOV · MANZIL YO‘Q · PUL YUBORMANG",
  "addReceiptTitle": "To‘lov chekini qo‘shing",
  "addReceiptBody": "Kamera/galereya/fayl. Sinovda serverga yuborilmaydi.",
  "cameraCapture": "Kamera bilan olish",
  "sampleTimer": "Namuna taymer — haqiqiy so‘rov yo‘q",
  "transferDetails": "O‘tkazma ma’lumotlari",
  "paymentDetailsStep": "To‘lov ma’lumotlari",
  "paymentConfirmStep": "To‘lovni tasdiqlash",
  "iPaidReceipt": "Men to‘ladim · Chek ekrani",
  "fromGallery": "Galereyadan tanlash",
  "chooseFile": "Fayl tanlash",
  "cameraFileSelected": "Kamera fayli tanlandi: {{name}}. Sinovda serverga yuklanmaydi.",
  "imageSelected": "Rasm tanlandi: {{name}}. Sinovda serverga yuklanmaydi.",
  "fileSelected": "Fayl tanlandi: {{name}}. Sinovda serverga yuklanmaydi.",
  "previewTest": "Sinov",
  "fileNotUploaded": "Fayl serverga yuklanmaydi",
  "bankSelect": "Bank tanlash",
  "depositBonusSample": "Depozit bonusi · namuna",
  "checkFinalAmount": "Yakuniy summani yaratilgan buyurtmada tekshiring.",
  "orderNumber": "Buyurtma raqami:",
  "amountDue": "To‘lanadigan summa:",
  "requestProcessing": "So‘rov qayta ishlanmoqda",
  "paymentCreated": "To‘lov so‘rovi muvaffaqiyatli yaratildi!",
  "completeTransferHint": "Quyidagi to‘lov ma’lumotlari bilan o‘tkazmani yakunlang.",
  "exactAmountWarn": "Diqqat! Faqat ko‘rsatilgan summani to‘g‘ri ma’lumotlar bilan yuboring.",
  "uploadReceiptAfter": "O‘tkazmadan keyin chekni yuklang.",
  "paymentInfo": "To‘lov ma’lumotlari",
  "cardHolderName": "Karta egasi nomi",
  "receiverName": "Oluvchi nomi",
  "accountNumber": "Hisob raqami",
  "previewDepositSelected": "SINOV: {{method}} — {{amount}} AZN tanlandi. Haqiqiy depozit yo‘q; pul yubormang.",
  "previewWithdrawChecked": "SINOV: {{method}} bo‘yicha {{amount}} AZN yechib olish tekshirildi. Haqiqiy so‘rov yo‘q.",
  "checkingFileSelection": "Fayl tanlovini tekshiryapsiz",
  "bonusSampleLine": "5%: {{bonus}} · jami: {{total}}",
  "phoneNumber": "Telefon raqami",
  "addressLabel": "manzili",
  "uploadReceiptReminder": "To‘lovdan keyin chekni yuklashni unutmang.",
  "previewWithdrawBanner": "SINOV: Haqiqiy yechib olish yuborilmaydi va balans o‘zgarmaydi.",
  "cardExpiry": "Karta muddati (Oy/Yil)",
  "checkRequest": "So‘rovni tekshirish",
  "bonusNotOnReal": "Haqiqiy balansga hisoblanmaydi.",
  "realBalance": "Asosiy balans",
  "gameCurrencies": "O‘yin valyutalari",
  "walletCta": "Hamyon",
  "closeGameFirst": "Faol o‘yinda ochiq tikish bor. Avval o‘yinni yoping, keyin valyutani o‘zgartiring.",
  "regionLabel": "To‘lov mintaqasi",
  "regionCryptoOnly": "Bu mintaqada faqat kriptovalyuta to‘lovlari mavjud",
  "tonConnectTitle": "TON Connect orqali depozit",
  "tonConnectWallet": "TON hamyonni ulang",
  "tonPayConfirm": "To‘lovni hamyonda tasdiqlang",
  "tonDisconnectWallet": "Hamyonni uzish",
  "tonWalletStatus": "Hamyon holati",
  "tonWalletNotConnected": "Ulanmagan",
  "tonWalletConnected": "Ulangan · {{address}}",
  "tonWalletConnectedHint": "TON hamyoningiz muvaffaqiyatli bog‘landi.",
  "tonWalletDisconnected": "Hamyon uzildi.",
  "tonWalletConnectFailed": "Hamyonni ulash amalga oshmadi.",
  "tonConnectWalletFirst": "Avval TON hamyonni ulang.",
  "tonConfirmInWallet": "To‘lovni hamyoningizda tasdiqlang.",
  "tonPendingAdminReview": "Depozit so‘rovi yaratildi. To‘lov admin tekshiruvini kutmoqda.",
  "tonDepositCreated": "TON depozit so‘rovi yaratildi. Hamyon orqali to‘lovni yakunlang.",
  "tonPaymentCancelled": "To‘lov bekor qilindi yoki yakunlanmadi.",
  "tonPaymentMissing": "To‘lov ma’lumotlari yo‘q. Qayta urinib ko‘ring.",
  "tonPaymentProofMissing": "Hamyon to‘lov dalilini qaytarmadi. To‘lov o‘tmagan bo‘lsa, qayta urinib ko‘ring.",
  "tonWarnNativeOnly": "Faqat native TON yuboring. Boshqa token yoki tarmoq mablag‘ yo‘qotilishiga olib kelishi mumkin.",
  "tonWarnAdminReview": "Hamyon tasdiqi balans oshishi demak emas. Balans admin tekshiruvidan keyin oshadi.",
  "gameCurrency": "O‘yin valyutasi"
}
